import { render, staticRenderFns } from "./PageMapping.vue?vue&type=template&id=de6d80c4&"
import script from "./PageMapping.vue?vue&type=script&lang=js&"
export * from "./PageMapping.vue?vue&type=script&lang=js&"
import style0 from "./PageMapping.vue?vue&type=style&index=0&id=de6d80c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports